var CurrentUser = require("lib/account/CurrentUser");
var ImageIcon = require("components/utility/icons/ImageIcon");
var Glyphicon = require("components/utility/icons/Glyphicon");
var UserAvatar = require("components/avatars/UserAvatar");
var StandInAvatar = require("components/avatars/StandInAvatar");
var Formats = require("lib/academic/Formats");
var Skillsets = require("lib/academic/Skillsets");
var NameLookup = require("lib/data/NameLookup");
var TextTypes = require("lib/academic/TextTypes");
var ReactTooltip = require("react-tooltip");

require("writing/responses/response_tile.scss")

class ResponseTile extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onClick() {
		if (this.props.onClick) {
			this.props.onClick(this.props.response);
		}
	}

	onRemove(e) {
		e.stopPropagation();
		$wr.nope(e)
		if (this.props.onRemove) {
			this.props.onRemove(this.props.response);
		}
	}

	render() {
		var response = this.props.response;
		var activity = response.activity;

		if (response.text && _.size(response.text) > 0) {
			var textInfo = (
				<p className="bookTitle">
					For: <em>{ response.text.title }</em>
				</p>
			)
		} else {
			var textInfo = (
				<p className="bookTitle">
					<em>Text provided</em>
				</p>
			)
		}

		if (this.props.user) {
			var mainUser = (
				<span>
					<UserAvatar user={ this.props.user } maxWidth={ 30 } />{" "}
					{ this.props.user.display_name }
				</span>
			);

			if (response.mirror_user_ids && NameLookup.isLoaded()) {
				var mirrorIDs = _.without(response.mirror_user_ids, this.props.user.id);
				var otherNames = NameLookup.getNames(mirrorIDs);

				var otherUsers = (<span>{ ", " + otherNames.join(", ") }</span>);
			}

			var userLine = (
				<div className="userLine">
					{ mainUser }
					{ otherUsers }
				</div>
			);
		} else if (this.props.userName) {
			var userLine = (
				<div className="userLine">
					<span>
						<StandInAvatar maxWidth={ 30 } />{" "}
						{ this.props.userName }
					</span>
				</div>
			);
		}
		if (response.edited_at) {
			var edited = (<span className="date">Edited: { $wr.formatDate(response.edited_at) }</span>)
		}

		var activityTitleClassName = "text-center activityTitle"
		if (this.props.onRemove) {
			activityTitleClassName += " narrow";
			var removeButton = (
				<button className="btn btn-link removeButton" onClick={ this.onRemove }
					data-tip="Archive Response">
					<Glyphicon icon="remove" />
				</button>
			);
		}

		var textContent = ( 
			<div className="responseInfo smallText">
				<div className="responseHeader">
					<p className={ activityTitleClassName }>
						<strong>{ activity.format_summary.title }</strong>{" "}
					</p>
					{ removeButton }
					<ReactTooltip effect="solid" place="left" />
				</div>	
				{ userLine }
				<div className="responseBody">
					{ textInfo }
					<span className="date">Completed: { $wr.formatDate(response.created_at) }</span>
					{edited}
				</div>
			</div>
		);

		var className = "tile responseTile";
		if (this.props.onClick) {
			className += " clickableElement";
		}

		var skillset = activity.format_summary.skillset;
		return (
			<div className={ className } onClick={ this.onClick }>
				{ textContent }
				<div className="skillsetTitle smallText">
					<img src={ Skillsets.getIcon(skillset) } className="skillsetImg" />
					<span className="itemName">
						{ Skillsets.getName(skillset) }
					</span>
				</div>
			</div>
		)
	}

	componentDidMount() {
		if (!NameLookup.isLoaded() && this.props.user && Formats.isCollaboration(this.props.response.activity.format_summary.format_class)) {
			NameLookup.loadStudentNames(function() {
				this.forceUpdate();
				setTimeout(function() {
					$(window).trigger("masonry-update");
				}, 100);
			}.bind(this));
		}
	}
};

ResponseTile.propTypes = StrictPropTypes({
	// The response
	response: PropTypes.object.isRequired,

	// Function to call when the tile is clicked
	onClick: PropTypes.func,

	// Function to archive the response. Will show an "X" if present
	onRemove: PropTypes.func,

	// If this is present, we'll show the student and the avatar
	user: PropTypes.object,

	// If this is present, we'll show this name and a default avatar
	userName: PropTypes.string,
});

module.exports = ResponseTile;



// WEBPACK FOOTER //
// ./modules/components/writing/responses/ResponseTile.js